import { SpraypaintBase } from 'spraypaint';
import baseUrl from '../helpers/baseUrl';

/*
 * We don't want to authenticate requests to the onboarding endpoint
 *
 * This means we can't extend from BaseApplicationRecord
 */

const ApplicationRecord = SpraypaintBase.extend({
  static: {
    baseUrl: baseUrl(),
    clientApplication: process.env.SPRAYPAINT_CLIENT_APPLICATION,
    keyCase: { client: 'snake', server: 'snake' },
    apiNamespace: '/onboardings',
  },
});

export default ApplicationRecord;
